/**
 * Temporary Hook needed for initial release of Curbside
 * When a store has Curbside enabled, and the service mode is TAKEOUT
 * The TAKEOUT service mode will be modified to work like CURBSIDE
 */

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { ServiceMode, useOrderContext } from 'state/order';
import { useStoreContext } from 'state/store';

export const useIsModifiedTakeout = () => {
  const enabledModifiedTakeout = useFlag(LaunchDarklyFlag.ENABLE_MODIFIED_TAKEOUT);
  const order = useOrderContext();
  const { store } = useStoreContext();

  if (!order) {
    return false;
  }

  const { serviceMode } = order;
  const isTakeout = serviceMode === ServiceMode.TAKEOUT;
  const storeHasFrontCounterClosed =
    'frontCounterClosed' in store ? store.frontCounterClosed : false;

  return enabledModifiedTakeout && storeHasFrontCounterClosed && isTakeout;
};
